export enum TimeCardGroupStatus {
  InProgress = "InProgress",
  PendingInput = "PendingInput",
  Approved = "Approved",
  Completed = "Completed"
}
